import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, X as CloseIcon, UserIcon, PhoneIcon } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-254">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-255">
        <div className="flex justify-between h-16" data-id="element-256">
          <div className="flex items-center" data-id="element-257">
            <Link to="/" className="flex-shrink-0 flex items-center" data-id="element-258">
              <span className="text-blue-600 text-xl font-bold" data-id="element-259">MyTourix</span>
            </Link>
            <nav className="hidden md:ml-10 md:flex md:space-x-8" data-id="element-260">
              <Link to="/" className="px-3 py-2 text-sm font-medium text-gray-900 hover:text-blue-600" data-id="element-261">
                Home
              </Link>
              <Link to="/search?type=flight" className="px-3 py-2 text-sm font-medium text-gray-500 hover:text-blue-600" data-id="element-262">
                Flights
              </Link>
              <Link to="/search?type=hotel" className="px-3 py-2 text-sm font-medium text-gray-500 hover:text-blue-600" data-id="element-263">
                Hotels
              </Link>
              <Link to="/search?type=package" className="px-3 py-2 text-sm font-medium text-gray-500 hover:text-blue-600" data-id="element-264">
                Flight + Hotel
              </Link>
            </nav>
          </div>
          <div className="hidden md:flex items-center space-x-4" data-id="element-265">
            <a href="tel:+1234567890" className="flex items-center text-sm font-medium text-gray-500 hover:text-blue-600" data-id="element-266">
              <PhoneIcon className="h-4 w-4 mr-1" data-id="element-267" />
              <span data-id="element-268">Support</span>
            </a>
            <Link to="/account" className="flex items-center text-sm font-medium text-gray-500 hover:text-blue-600" data-id="element-269">
              <UserIcon className="h-4 w-4 mr-1" data-id="element-270" />
              <span data-id="element-271">Account</span>
            </Link>
          </div>
          <div className="flex items-center md:hidden" data-id="element-272">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-500 hover:text-blue-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500" data-id="element-273">
              {isMenuOpen ? <CloseIcon className="h-6 w-6" data-id="element-274" /> : <MenuIcon className="h-6 w-6" data-id="element-275" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden" data-id="element-276">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-277">
            <Link to="/" className="block px-3 py-2 text-base font-medium text-gray-900 hover:text-blue-600" data-id="element-278">
              Home
            </Link>
            <Link to="/search?type=flight" className="block px-3 py-2 text-base font-medium text-gray-500 hover:text-blue-600" data-id="element-279">
              Flights
            </Link>
            <Link to="/search?type=hotel" className="block px-3 py-2 text-base font-medium text-gray-500 hover:text-blue-600" data-id="element-280">
              Hotels
            </Link>
            <Link to="/search?type=package" className="block px-3 py-2 text-base font-medium text-gray-500 hover:text-blue-600" data-id="element-281">
              Flight + Hotel
            </Link>
            <a href="tel:+1234567890" className="flex items-center px-3 py-2 text-base font-medium text-gray-500 hover:text-blue-600" data-id="element-282">
              <PhoneIcon className="h-4 w-4 mr-2" data-id="element-283" />
              <span data-id="element-284">Support</span>
            </a>
            <Link to="/account" className="flex items-center w-full text-left px-3 py-2 text-base font-medium text-gray-500 hover:text-blue-600" data-id="element-285">
              <UserIcon className="h-4 w-4 mr-2" data-id="element-286" />
              <span data-id="element-287">Account</span>
            </Link>
          </div>
        </div>}
    </header>;
};
export default Header;